import Content from "../services/Content";

export default {

    props: ['locale','profile', 'tags'],

    data: () => { return {
        posts: [],
    }},

    mounted: function() {
        this.refreshPosts();
    },

    methods: {
        refreshPosts: function() {
            let tags = false;
            
            if(this.tags){
                tags = Object.values(this.tags);
            }

            Content.GetFeaturedPosts(this.locale, this.profile, tags)
                .then((posts) => {
                    this.posts = posts;
                })
        }
    }
}
